import {Component, Input, OnInit} from "@angular/core";
import {Loading, LoadingController, Platform} from "ionic-angular";
import {MIME_TYPES} from '../../../model/MimeType';
import {ConfigServiceProvider} from "../../../modules/core/services/config-service/config-service";
import {AuthenticationServiceProvider} from "../../../modules/core/services/authentication-service/authentication-service";
import {FileTransfer, FileTransferObject} from "@ionic-native/file-transfer";
import {FileOpener} from "@ionic-native/file-opener";
import {File} from '@ionic-native/file';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'sellions-secured-file',
  template: `
    <a tappable (tap)="loadFile()">
      <ng-content></ng-content>
    </a>
  `
})
export class SellionsSecuredFileComponent implements OnInit {
  @Input() private href: string;
  @Input() private name: string;
  @Input('content-type') private content: string;
  private fileTransferObj: FileTransferObject;
  private loading: Loading;

  constructor(
    private authenticationService: AuthenticationServiceProvider,
    private configService: ConfigServiceProvider,
    private loadingCtrl: LoadingController,
    private fileTransfer: FileTransfer,
    private fileOpener: FileOpener,
    private platform: Platform,
    private http: HttpClient,
    private file: File) {
  }

  loadFile() {
    this.authenticationService.getAccessToken().then((token) => {
        this.downloadAndOpenFile(token);
      }
    );
  }

  private downloadAndOpenFile(token: String) {
    this.loading = this.loadingCtrl.create({
      content: 'Trwa pobieranie...'
    });
    this.loading.present();

    if (this.isInBrowser()) {
      this.downloadAttachmentInNewBrowserWindow();
      return;
    }

    this.fileTransferObj.download(this.href, this.file.dataDirectory + this.name, true, {
      headers: {
        Authorization: `Bearer ` + token
      }
    })
      .then(e => {
        console.log(e);
        this.fileOpener.open(this.file.dataDirectory + this.name, MIME_TYPES[this.name.split('.').pop()])
          .catch(e => console.error(e));
        this.loading.dismiss();
      })
      .catch(e => {
        this.loading.dismiss();
        console.log(e);
        console.error('[Secured-File] Failed: ', this.href);
      });
  }

  ngOnInit(): void {
    this.fileTransferObj = this.fileTransfer.create();
  }

  downloadAttachmentInNewBrowserWindow() {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    this.http.get(this.href, httpOptions).subscribe(it => {
      const fileObjectURL = URL.createObjectURL(it);
      window.open(fileObjectURL);
      this.loading.dismiss();
    });
  }

  private isInBrowser(): boolean {
    return !this.platform.is('ios') && !this.platform.is('android');
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-secured-file/sellions-secured-file.ts